<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
      <el-form-item
          v-if="1"
          label="用户账号"
          prop="userId"
      >
          <GridSelect
              style="width: 175.6px"
              title="选择用户"
              labelName='userName'
              labelValue='id'
              :value="queryForm.userId"
              :limit="1"
              size="small"
              @getValue='(value) => {queryForm.userId = value}'
              placeholder="请选择用户"
              :columns="USER_code"
              :searchs="USER_search"
              dataListUrl="/mpp/user/findList"
              entityBeanName="mppUser"
              queryEntityUrl="/mpp/user/get"
          >
          </GridSelect>
      </el-form-item>



              <el-form-item label="货币类型">
                  <el-select
                      style="width:175.6px"
                      v-model="queryForm.currencyType"
                      size="small"
                      placeholder="请选择"
                  >
                      <el-option v-for="(item,index) in currencyTypeEnumList" :label="item.value" :value="item.key" > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="是否结束">
                  <el-select
                      style="width:175.6px"
                      v-model="queryForm.isFinished"
                      size="small"
                      placeholder="请选择"
                  >
                      <el-option v-for="(item,index) in yesNoEnumList" :label="item.value" :value="item.key" > </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppMoneyReleaseList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addMppMoneyRelease"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editMppMoneyRelease(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppMoneyRelease(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMppMoneyReleaseList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMppMoneyReleaseList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
        height="100%"
      :data="mppMoneyReleaseList"
      row-key="id"
      border
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        label="用户"
        width="180"
      >
      <template slot-scope="scope">
        <div v-if="scope.row.user">
          <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
          <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
          <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
          <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
        </div>
        <div v-else>--</div>
      </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money"
        label="金额"
        width="180"
      > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="releaseMode"
	    label="释放模式"
	    width="120"
	  > </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="releaseRatio"
	    label="释放比例"
	    width="120"
	  > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currencyType"
        label="货币类型"
        width="180"
      >
          <template scope='scope'>
              <div>{{currencyTypeStatusString(scope.row.currencyType)}}</div>
          </template>
      </el-table-column>
	  
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="releaseTo"
	    label="释放到哪个货币类型"
	    width="180"
	  >
	      <template scope='scope'>
	          <div>{{currencyTypeStatusString(scope.row.releaseTo)}}</div>
	      </template>
	  </el-table-column>
      
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="intervalHour"
        label="间隔小时数"
        width="180"
      > </el-table-column>
      
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="releaseTimes"
        label="已经释放的次数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="isFinished"
        label="是否结束"
        width="180"
      >
<!--          <template scope="scope">-->
<!--              <span v-if="scope.row.isFinished === 1">是</span>-->
<!--              <span v-if="scope.row.isFinished === 0">否</span>-->
<!--          </template>-->
          <template scope='scope'>
              <div>{{yesNoStatusString(scope.row.isFinished)}}</div>
          </template>
      </el-table-column>
	  <el-table-column
	    :show-overflow-tooltip="true"
	    align="center"
	    prop="createTime"
	    label="创建时间"
	    width="180"
	  > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="100"
      >
        <template slot-scope="scop">
          <div class="operation">
<!--            <div @click="checkMppMoneyRelease(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Eye24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">查看</span>-->
<!--            </div>-->
<!--            <div @click="editMppMoneyRelease(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteMppMoneyRelease(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppMoneyReleaseStates[mppMoneyReleaseState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppMoneyRelease"
          ref="mppMoneyReleaseForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户id"
            prop="userId"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.userId"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="金额"
            prop="money"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.money"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="货币类型"
            prop="currencyType"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.currencyType"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="释放总次数"
            prop="totalTimes"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.totalTimes"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="间隔小时数"
            prop="intervalHour"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.intervalHour"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="几个小时后开始计算"
            prop="startHour"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.startHour"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="释放到哪个货币类型"
            prop="releaseTo"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.releaseTo"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="已经释放的次数"
            prop="releaseTimes"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.releaseTimes"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否结束"
            prop="isFinished"
          >
            <el-input
              size="small"
              v-model="mppMoneyRelease.isFinished"
              :disabled="mppMoneyReleaseState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppMoneyReleaseState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppMoneyReleaseList();
                    this.getMppMoneyReleaseList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppMoneyReleaseList();
                    this.getMppMoneyReleaseList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                yesNoEnumList:[], //yes_no枚举
                currencyTypeEnumList:[], //currency_Type枚举
                queryForm:{
                     userId: '', //用户id
                     currencyType: '', //货币类型
                     isFinished: '', //是否结束
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppMoneyReleaseState: 'add',
                mppMoneyReleaseStates: {
                    add: '新建mpp_money_release',
                    check: '查看mpp_money_release',
                    edit: '修改mpp_money_release'
                },

                multipleSelection: [],
                mppMoneyReleaseList: [],
                mppMoneyRelease: {
                    userId: '', //用户id
                    money: '', //金额
                    currencyType: '', //货币类型
                    totalTimes: '', //释放总次数
                    intervalHour: '', //间隔小时数
                    startHour: '', //几个小时后开始计算
                    releaseTo: '', //释放到哪个货币类型
                    releaseTimes: '', //已经释放的次数
                    isFinished: '', //是否结束
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
                    money: [{ required: true, message: '金额不能为空', trigger: 'blur' }],
                    currencyType: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
                    totalTimes: [{ required: true, message: '释放总次数不能为空', trigger: 'blur' }],
                    intervalHour: [{ required: true, message: '间隔小时数不能为空', trigger: 'blur' }],
                    startHour: [{ required: true, message: '几个小时后开始计算不能为空', trigger: 'blur' }],
                    releaseTo: [{ required: true, message: '释放到哪个货币类型不能为空', trigger: 'blur' }],
                    releaseTimes: [{ required: true, message: '已经释放的次数不能为空', trigger: 'blur' }],
                    isFinished: [{ required: true, message: '是否结束不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppMoneyReleaseList();
            this.getYesNo();
            this.getCurrencyType();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppMoneyReleaseList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppMoneyReleaseList = [];
            },
            resetDialog() {
                this.mppMoneyReleaseState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户id
                      currencyType: '', //货币类型
                      isFinished: '', //是否结束
                };
                this.getMppMoneyReleaseList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppMoneyRelease = {
                      userId: '', //用户id
                      money: '', //金额
                      currencyType: '', //货币类型
                      totalTimes: '', //释放总次数
                      intervalHour: '', //间隔小时数
                      startHour: '', //几个小时后开始计算
                      releaseTo: '', //释放到哪个货币类型
                      releaseTimes: '', //已经释放的次数
                      isFinished: '', //是否结束
                };
            },
            submitForm() {
                if (this.mppMoneyReleaseState == 'add') {
                    this.$refs.mppMoneyReleaseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/mppmoneyrelease/add`,{ ...this.mppMoneyRelease }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppMoneyReleaseList();
                                    this.resetDialog();
                                    this.getMppMoneyReleaseList();
                                }
                            });
                        }
                    });
                } else if (this.mppMoneyReleaseState == 'edit') {
                    this.$refs.mppMoneyReleaseForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/biz/mppmoneyrelease/edit`,{ ...this.mppMoneyRelease }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppMoneyReleaseList();
                                    this.resetDialog();
                                    this.getMppMoneyReleaseList();
                                }
                            });
                        }
                    });
                }
            },
            addMppMoneyRelease() {
                this.showDialog = true;
                this.mppMoneyReleaseState = 'add';
            },
            checkMppMoneyRelease(mppMoneyReleaseId) {
                console.log(mppMoneyReleaseId);
                this.currentMppMoneyReleaseId = mppMoneyReleaseId;

                this.getMppMoneyReleaseById();
                this.showDialog = true;
                this.mppMoneyReleaseState = 'check';
            },
            editMppMoneyRelease(mppMoneyReleaseId) {
                console.log('mppMoneyRelease', mppMoneyReleaseId);
                if (mppMoneyReleaseId) {
                    this.currentMppMoneyReleaseId = mppMoneyReleaseId;
                    this.getMppMoneyReleaseById();
                } else {
                    this.mppMoneyRelease = { ...this.mppMoneyRelease, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppMoneyReleaseState = 'edit';
            },
            deleteMppMoneyRelease(mppMoneyReleaseId) {
                let ids = '';
                if (mppMoneyReleaseId) {
                    ids = mppMoneyReleaseId;
                } else {
                    ids = this.multipleSelection.map((mppMoneyRelease) => mppMoneyRelease.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/biz/mppmoneyrelease/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppMoneyReleaseList();
                                this.getMppMoneyReleaseList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppMoneyReleaseList() {
                this.resetMppMoneyReleaseList();
                this.getMppMoneyReleaseList();
            },
            getMppMoneyReleaseList(query = {}) {
                this.loading = true;
                get(`/biz/mppmoneyrelease/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppMoneyReleaseList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMppMoneyReleaseById() {
                get(`/biz/mppmoneyrelease/get`,{ id: this.currentMppMoneyReleaseId }).then((res) =>{
                    if(res.success){
                      this.mppMoneyRelease = { ...this.mppMoneyRelease, ...res.mppMoneyRelease };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppMoneyReleaseList() {
                //this.btnLoading = true;
                exprotExcel(`/biz/mppmoneyrelease/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/biz/mppmoneyrelease/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/biz/mppmoneyrelease/importData`,formData);
              this.refreshMppMoneyReleaseList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppMoneyReleaseList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppMoneyReleaseList();
            },

            // 获取yes_no枚举
            getYesNo(){
                get('/mpp/utils/getEnum',{
                    enumType:'yes_no'
                }).then((res)=>{
                    this.yesNoEnumList = res.enumList
                })
            },

            //yes_no显示
            yesNoStatusString(key){
                for (const index in this.yesNoEnumList) {
                    if(this.yesNoEnumList[index].key == key){
                        return this.yesNoEnumList[index].value
                    }
                }
            },

            //获取currency_type枚举
            getCurrencyType(){
                get('/mpp/utils/getEnum',{
                    enumType:'currency_type'
                }).then((res)=>{
                    this.currencyTypeEnumList = res.enumList
                })
            },

            //currency_type显示
            currencyTypeStatusString(key){
                for (const index in this.currencyTypeEnumList) {
                    if(this.currencyTypeEnumList[index].key == key){
                        return this.currencyTypeEnumList[index].value
                    }
                }
            },
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
